(ns story-builder.story-editor.ruler.sub
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::ruler
 (fn [db _]
   (get db :ruler)))

(rf/reg-sub
 ::ruler?
 :<- [::ruler]
 (fn [db _]
   (:ruler/ruler? db false)))

(rf/reg-sub
 ::guides?
 :<- [::ruler]
 (fn [db _]
   (:ruler/guides? db false)))

(rf/reg-sub
 ::custom-guides
 :<- [:ui/landscape?]
 :<- [:utils/db-persistent]
 (fn [[landscape? db] _]
   (get-in db [:story :editor-config :ruler (if landscape? :landscape :portrait)])))

(rf/reg-sub
 ::demo-guide
 :<- [::ruler]
 (fn [db _]
   (:ruler/demo-guide db)))

(rf/reg-sub
 ::selected-guide
 :<- [::ruler]
 (fn [db _]
   (:ruler/selected-guide db)))

(rf/reg-sub
 ::dragging-guide?
 :<- [::ruler]
 (fn [db _]
   (some? (:ruler/drag-info db))))

(rf/reg-sub
 ::drag-pos
 :<- [::ruler]
 (fn [db _]
   (get-in db [:ruler/drag-info :pos])))
